module.exports = __webpack_public_path__ + "static/media/tom-ford-black-orchid-velvet.ddf81e08.png";